import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from "./ConstantsWomenCalculator";
import { Conception_EndPoint } from "./ConstantsWomenCalculator";
import { ConceptionTable } from "./Tables";
import { CyrcleLengthcomponet } from "./Component";
import SharedHelmet from "../Helmet";
const OG_URL = 'https://do-calculate.com/calculator/fr/conception/';
const TITLE = 'Calculatrice de date de conception - Calculer les jours de conception facilement et avec précision';
const DESCRIPTION =
  "Calculatrice de date de conception - Calculer les jours de conception facilement et avec précision pour obtenir des estimations utiles en sante feminine et suivi du cycle. Entrez vos informations et recevez des resultats rapides pour mieux planifier.";
const KEYWORDS =
  "de date de conception r les jours de conception facilement et avec précision, calculatrice de date de conception r les jours de conception facilement et avec précision, calcul en ligne, sante feminine, cycle, grossesse, resultat rapide";
const apiEndpoint = `${SERVER_URL}/${Conception_EndPoint}`;
function ConceptionCalculator() {
  const [firstDayOfLastPeriod, setFirstDate] = useState();
  const [cycleLength, setCyrcleLength] = useState(28);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleDateChange = (event) => {
    setFirstDate(event.target.value);
  };
  const calculateConception = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ firstDayOfLastPeriod, cycleLength }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data["result"]);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="ltr">
       <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}> {TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Avec la calculatrice de date de conception, vous pouvez découvrir 
                  les jours présentant un taux de fertilité élevé, c'est-à-dire le 
                  moment de l'ovulation, pour aligner vos rapports sexuels et réaliser 
                  une grossesse. La calculatrice de date de conception aide à 
                  déterminer les jours les plus fertiles de votre mois, en fonction 
                  des dates de vos derniers cycles menstruels et de leur durée. De 
                  cette manière, vous pouvez déterminer les meilleurs moments pour 
                  avoir des relations avec votre partenaire et tenter une grossesse. 
                  Pour utiliser la calculatrice de date de conception, veuillez 
                  suivre les étapes simples ci-dessous:
                </p>
                <ul>
                  <li>
                    Entrez la date du premier jour de vos dernières règles dans le 
                    champ prévu au format jour/mois/année, par exemple: 01/04/2009.
                  </li>
                  <li>
                    Pour plus de précision, vous pouvez remplir les champs 
                    "cycle avant-dernier" et "deuxième cycle avant-dernier" si vous 
                    les connaissez.
                  </li>
                  <li>
                    Sélectionnez dans le deuxième champ la durée de votre cycle 
                    menstruel, et si vous n'êtes pas sûre, nous vous recommandons de 
                    choisir 28 jours.
                  </li>
                  <li>Cliquez sur le bouton "Calculer".</li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Calculatrice de timing de conception{" "}
                </div>
                <hr />
                <br />
                <div className=" form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label className="form-label" style={{marginRight: "10px"}}>
                      <strong>Premier jour</strong> de vos dernières règles
                    </label>
                  </b>
                  <br />
                  <input
                    type="date"
                    id="weightNumber"
                    value={firstDayOfLastPeriod}
                    onChange={handleDateChange}
                    className="form-control ml-2"
                    style={{ width: "145px" }}
                    placeholder="175"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="CycleLength" className="form-label" style={{marginRight: "10px"}}>
                      Durée moyenne entre les cycles
                    </label>
                  </b>
                  <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                  <div className="input-group-append">
                    <span className="input-group-text ">jours</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateConception}
                  >
                    Calculer
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Erreur :</u>
                    </b>{" "}
                    Veuillez entrer tous les champs correctement
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Résultats:
                      </div>
                    </h4>
                    <hr />
                    <ConceptionTable result={result}></ConceptionTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Description de la calculatrice de timing de conception</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "15px" }}>
                  <u><b>La fenêtre fertile</b></u>
                </h3>
                <p>
                  La fenêtre fertile est une période qui dure environ trois jours au cours de laquelle la possibilité de grossesse chez la femme est la plus élevée. La conception est généralement définie comme le début de la grossesse, lorsque l'ovule est fécondé. Cela peut se produire soit par la fécondation in vitro, soit par les rapports sexuels. Dans le cas des rapports sexuels, le sperme reste viable dans le corps de la femme pendant jusqu'à 5 jours (et peut durer jusqu'à 7 jours dans certains cas). Ainsi, lorsque vous essayez de concevoir, les rapports sexuels réguliers 5 jours avant l'ovulation et au jour de l'ovulation lui-même peuvent augmenter la probabilité de fécondation réussie. C'est ce qu'on appelle la fenêtre fertile. De plus, les études ont montré que dans cette fenêtre, les 3 derniers jours sont les plus fertiles, et les rapports sexuels au cours de cette période aboutiront à une grossesse dans environ 30% des cas.
                </p>
                <hr />
                <h3 style={{ fontSize: "15px" }}>
                  <u><b>L'amour et la procréation</b></u>
                </h3>
                <p>
                  Le désir d'avoir des enfants est lié à l'amour pour votre partenaire et pour l'enfant que vous verrez grandir. Malgré la profondeur de ce désir chez la plupart des couples, la vie intervient souvent. Nous ressentons du stress et de l'anxiété en raison du travail et nous passons la plupart de notre temps à gérer les préoccupations quotidiennes et les tâches ménagères. Par conséquent, nous ne trouvons pas assez de temps ou nous n'avons pas envie de faire l'amour autant que nous le souhaiterions. Cependant, la première chose à savoir lorsque vous essayez de concevoir est que les rapports sexuels réguliers avec votre partenaire sont la meilleure préparation possible. Lorsque vous essayez de concevoir, vous devriez avoir des rapports sexuels régulièrement - au moins deux ou trois fois par semaine - même lorsque vous ne pensez pas nécessairement être fertile ou proche du jour de l'ovulation. Les rapports sexuels réguliers préparent le corps de la femme à la procréation et élèvent le niveau hormonal qui y est associé. Des niveaux de fertilité réduits eux-mêmes sont associés à une diminution de la libido. Votre mode de vie et vos relations améliorent les chances de conception. Les rapports sexuels réguliers créent également des conditions plus favorables dans le vagin. Le mucus cervical de haute qualité (ou semblable à du blanc d'œuf) améliore la fertilité en créant des conditions plus favorables dans le vagin qui aident à protéger les spermatozoïdes et à prolonger leur durée de vie effective, prolongeant ainsi la fenêtre fertile.
                </p>
                <hr />
                <h3 style={{ fontSize: "15px" }}>
                  <u><b>Mettre la fenêtre de fertilité à votre avantage</b></u>
                </h3>
                <p>
                  Après avoir établi un modèle de rapports sexuels réguliers, vous devez reconnaître ces quelques jours avant l'ovulation qui incluent le jour d'ovulation lui-même. L'identification de cette "fenêtre" augmentera considérablement vos chances de concevoir. La calculatrice de conception mentionnée ci-dessus peut vous aider dans le processus de suivi de votre cycle biologique personnel, vous aidant ainsi à identifier votre fenêtre de fertilité personnelle. Pour utiliser la calculatrice, enregistrez le premier jour de votre cycle actuel. Ensuite, enregistrez la durée du cycle jusqu'au cycle suivant.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            <h2>Questions fréquemment posées</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Que se passe-t-il pendant la fécondation?</h3>
              </div>
              <div className="info-section-body">
                À l'intérieur de vos ovaires chaque mois, un ensemble d'ovules commence à croître dans de petits sacs remplis de liquide appelés follicules. L'ovulation se produit lorsqu'un ovule éclate hors du follicule, et cela se produit généralement environ deux semaines avant le début de votre période menstruelle. Après la libération de l'ovule du follicule, votre corps libère une hormone qui aide à épaissir la muqueuse de votre utérus en préparation à recevoir l'ovule. L'ovule se déplace dans la trompe de Fallope où la fécondation se produit. L'ovule reste dans la trompe de Fallope pendant environ 24 heures en attente de fécondation par un seul spermatozoïde.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Qu'est-ce que la fécondation?</h3>
              </div>
              <div className="info-section-body">
                Après l'ovulation, votre ovule reste dans la trompe de Fallope pendant 12 à 24 heures en attente de fécondation par l'un des 250 millions de spermatozoïdes (en moyenne) libérés par votre partenaire lors de l'éjaculation. Lorsque votre partenaire éjacule, les spermatozoïdes se déplacent à travers votre vagin et dans votre utérus où se trouve l'ovule fécondé dans la trompe de Fallope. Seuls environ 400 spermatozoïdes parviennent à atteindre l'ovule après un voyage prenant environ 10 heures, selon la moyenne.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Quand la fécondation se produit-elle?</h3>
              </div>
              <div className="info-section-body">
                Pour que la fécondation se produise, les spermatozoïdes doivent atteindre l'ovule dans une fenêtre de temps spécifique. Les spermatozoïdes peuvent rester en vie jusqu'à 72 heures après l'éjaculation, mais l'ovule ne peut rester que 24 heures après l'ovulation. Si les spermatozoïdes atteignent la trompe de Fallope trop tôt, ils risquent de mourir avant l'arrivée de l'ovule. Et si les spermatozoïdes arrivent à la trompe de Fallope trop tard, l'ovule aura déjà bougé. De plus, l'ovule ne se trouve dans l'une des trompes de Fallope que pendant un mois donné.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Que se passe-t-il lorsque les spermatozoïdes atteignent l'ovule?
                </h3>
              </div>
              <div className="info-section-body">
                Avant la fécondation, des centaines de spermatozoïdes entourent l'ovule en essayant d'atteindre le noyau de l'ovule. Seul un spermatozoïde parvient à percer la membrane externe de l'ovule. Une fois que le spermatozoïde pénètre dans l'ovule, une réaction chimique instantanée empêche les autres spermatozoïdes de le pénétrer. Les chromosomes portés par le spermatozoïde et l'ovule se rassemblent, puis la fécondation se produit formellement. Environ une semaine plus tard, une boule composée d'environ 100 cellules (appelée blastocyste) atteint votre utérus et s'implante dans la muqueuse utérine.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Comment puis-je augmenter mes chances de concevoir?
                </h3>
              </div>
              <div className="info-section-body">
                Lorsqu'il s'agit de concevoir, le timing est la chose la plus importante. Pour augmenter vos chances de concevoir, essayez d'avoir des rapports sexuels à n'importe quel moment entre 72 heures avant l'ovulation et 24 heures après l'ovulation.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Comment puis-je me préparer pour la grossesse?</h3>
              </div>
              <div className="info-section-body">
                La meilleure chose que vous puissiez faire pour vous préparer à la grossesse est de mettre votre corps dans le meilleur état possible pour la procréation. Vous devez arrêter de consommer de l'alcool, de fumer et de prendre des médicaments, y compris les médicaments en vente libre. Vous devez informer votre médecin de vos projets de grossesse et demander son avis si vous devez continuer à prendre des médicaments sur ordonnance. Au moins trois mois avant de planifier d'essayer de concevoir, vous devriez commencer à prendre une multivitamine contenant au moins 400 microgrammes d'acide folique pour réduire le risque de malformations congénitales chez votre enfant.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Saurez-je immédiatement si je suis enceinte?
                </h3>
              </div>
              <div className="info-section-body">
                L'hormone de grossesse (hCG), également appelée hormone gonadotrope chorionique humaine, est présente dans votre sang après la fécondation. Cependant, les tests de grossesse ne peuvent pas détecter l'hCG dans votre urine jusqu'à ce que l'ovule s'implante dans votre utérus. Dans les meilleurs cas, les tests de grossesse en vente libre ne s'avéreront positifs que neuf à dix jours après l'ovulation. La plupart des femmes ne remarquent les symptômes précoces de la grossesse que après l'implantation, mais certaines peuvent noter les symptômes plus tôt.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ConceptionCalculator;
